import { z } from 'zod';

import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { EmployeeIdSearchFormFields } from './constants';
import type { EmployeeIdSearchFormValues } from './types';

export const employeeIdSearchFormValidationSchema = z.object({
  [EmployeeIdSearchFormFields.employeeId]: z
    .string()
    .nonempty({ error: REQUIRED_VALIDATION_MESSAGE })
    .refine(value => Boolean(value && value.trim().length > 0), { message: 'Required' }),
}) satisfies z.ZodType<EmployeeIdSearchFormValues>;
